<template>
    <div>
        <v-container class="dashboard mb-4 justify-center">
            <div class="checkprops d-flex flex-wrap">
                <div v-for="(item, idx) in checkprops" class="col-md-6 col-sm-12 classprop" v-bind:key="'props-' + idx" >
                    <template v-if="haslength(item.value)">
                        <label class='propertylabel'>{{ item.title }}:</label>
                        <span :class="'propertyvalue ' + item.style" v-if="item.link"><a :href="item.value" target="_blank">{{item.value}}</a></span>
                        <span :class="'propertyvalue ' + item.style" v-else>{{item.value}}</span>
                    </template>
                </div>
                <div v-if="description" class="classprop">
                    <label class='propertylabel'>Description:</label>
                    <span class="propertyvalue propsdescription">{{description}}</span>
                </div>
            </div>
            <div v-if="reports_checkstatus.reportConfig && reports_checkstatus.reportConfig.showConfig"  class="classprop">
                <a href="/#diagtools" target="_blank">Diagnostic Tools</a>
            </div>
        </v-container>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { filterDate } from "../lib/filter";

export default {
    name: "ReportCheckProperties",
    props: {},
    components: {},
    data() {
        return {};
    },
    computed: {
        ...mapState(["currentUser", "reports_checkstatus", "now"]),
        ...mapGetters("reports_checkstatus", ["mergedConfig"]),
        checkprops: function(){
            let display = this.mergedConfig.showprops || {};
                // // ( this.reports_checkstatus.reportConfig &&
                // //     ( (this.reports_checkstatus.reportConfig.check && this.reports_checkstatus.reportConfig.check.showprops) ||
                // //       (this.reports_checkstatus.reportConfig.showprops) )
                // // ) ||
                // {};
            display = Object.assign({}, display);
            let props = {};
            for(let k in this.reports_checkstatus.checkPropsSchema){
                if(k === "description") continue; // handled separately.
                if(display[k] === undefined){
                    display[k] = {}
                } else if(display[k] === true || display[k] === false){
                    display[k] = {
                        show: display[k]
                    }
                }
                props[k] = Object.assign({}, this.reports_checkstatus.checkPropsSchema[k], display[k]);
                if(!props[k].show){
                    // console.log('removing', k)
                    delete props[k];
                    continue;
                }

                if(props[k].value && typeof props[k].value === "function"){
                    props[k].value = props[k].value(this.reports_checkstatus.reportCheck, props[k].field);
                } else {
                    props[k].value = this.reports_checkstatus.reportCheck[props[k].field];
                }
                if(props[k].style && typeof props[k].style === "function"){
                    props[k].style = props[k].style(this.reports_checkstatus.reportCheck, props[k].field);
                }
                if(props[k].link && typeof props[k].style === "function"){
                    props[k].link = props[k].link(this.reports_checkstatus.reportCheck, props[k].field)
                }

            }
            // console.log('returning checkprops', props)
            return props;
        },
        description: function(){
            let display = this.mergedConfig.showprops || {};
                // ( this.reports_checkstatus.reportConfig &&
                //     ( (this.reports_checkstatus.reportConfig.check && this.reports_checkstatus.reportConfig.check.showprops) ||
                //       (this.reports_checkstatus.reportConfig.showprops) )
                // ) ||
                // {};

            if(!display || display.description === false || (display.description && !display.description.show)){
                // console.log("We will not show the description", display);
                return false;
            }
            // console.log("We will show the description if it exists.");

            let description = false;
            if(this.reports_checkstatus.reportCheck  && this.reports_checkstatus.reportCheck.description && this.reports_checkstatus.reportCheck.description.length){
                description = this.reports_checkstatus.reportCheck.description
            }
            // console.log("description is ", description);
            return description;
        }
    },
    methods: {
        message: function () {
            return (this.reports_checkstatus.reportResults && this.reports_checkstatus.reportResults[0] && this.reports_checkstatus.reportResults[0].m) || "";
        },
        haslength: function (val) {
            if (val !== undefined && (typeof val === "number" || (typeof val === "string" && val.length) || val === true || val === false ) ){
                return true
            } else {
                return false;
            }
        }
    },
    filters: {
        filterUpDown: function (val) {
            // if(data[k].enable === "inactive"){
            //     data[k].status = "inactive";
            // } else if(data[k].state === undefined){
            //     data[k].status = "not running";
            // } else if(data[k].state === 1){
            //     data[k].status = "up";
            // } else {
            //     data[k].status = "down";
            // }

            return val ? "Up" : "Down";
        },
        filterDate: function (val) {
            return filterDate(val);
        }
    }
};

</script>

<style scoped>
.propertylabel {
    font-size: 1.1em;
    font-weight: bold;
    display: inline-block;
    margin-right: 1em;
    width: 40%;
}

.propertyvalue {
    display: inline-block;
}

.isup {
    color: #388E3C;
    font-weight: bold;
    font-size: 1.1em;
}

.isdown {
    color: #f03d15;
    font-weight: bold;
    font-size: 1.1em;
}

.inactive {
    color: gray;
    font-weight: bold;
    font-size: 1.1em;
}

.classprop {
    padding: 4px 8px 4px 8px;
}

</style>